import { userLogout } from '@vt/apis/lib-ex/v2/users'
import { pick } from 'lodash-es'
import { useProjectStore } from '@vt/hooks'
import { routeTo } from '@vt/utils'
// import { useStorage } from '../index'

// FIXME: 这个项目获取用户数据应该从 project provider 去拿

// 判断环境
const DEP_ENV = process.env.REACT_APP_DEP
const RAP = process.env.REACT_APP_PROJECT
// const DEP_ENV = process.env.REACT_APP_DEP
export default function useUser() {
  // const { getGlobalValue, setGlobalValue } = useStorage()
  const { getVtProject } = useProjectStore((s) => pick(s, ['getVtProject']))

  const vtProject = getVtProject()
  // 清除token
  const removeToken = () => {
    vtProject.deleteStorage()
    // const extras = getGlobalValue('extras') || {}
    // delete extras.token
    // setGlobalValue('extras', extras)
  }

  const logOut = (tpl) => {
    userLogout().then((res) => {
      if (res.status === 200) {
        removeToken()
        if (tpl === 'yyzcjc') {
          const loginUrl =
            DEP_ENV === 'dev'
              ? 'https://testagent.sinooceangroup.com:8443/THRWebApp/passport-public/passport.htm?client_id=policymonitoring&redirect_uri=http://sinoocean-dev.survey.work?key=yyzcjc&response_type=code#/logout'
              : 'https://workflow.sinooceangroup.com/THRWebApp/passport.htm?client_id=Contacts&redirect_uri=http://sinoocean.survey.work?key=yyzcjc&response_type=code#/logout'
          window.location.href = loginUrl
        } else if (RAP.indexOf('voltali') !== -1) {
          routeTo(`/login?key=${tpl}`)
        } else {
          routeTo(`/cp/${RAP}/login?key=${tpl}`)
        }
      }
    })
  }

  return {
    userInfo: {},
    logOut,
  }
}
